module.exports = "/images/Ball pits.svg?4664d25e14b2419153550860756b5a33";